import { useEffect, useState } from 'react';
import { Card, Button, Col, Row } from 'antd';
import { handleDeleteApi } from '@/api/crud';
import GlobalDivider from '@/utils/divider/GlobalDivider';
import '../defaultBarcodeCSS.css';
import { barcodeApiEndPoints } from '@/api/endpoints';
import { useLocation, useNavigate } from 'react-router-dom';
import { DeleteFilled, EditFilled } from '@ant-design/icons';
import Link from 'antd/es/typography/Link';
import GlobalModal from '@/utils/modal/Modal';
import { Back } from '../back';

const PRNsettings = () => {
  const [open, setOpen] = useState(false);
  const [delId, setDelId] = useState(null);
  const [barcodePrintFormats, setBarcodePrintFormats] = useState([]);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [refetch, setRefetch] = useState(false);
  const { branchId, referenceId } = location.state || [];

  const handleOk = async () => {
    setOpen(false);
    await handleDeleteApi(
      delId,
      barcodeApiEndPoints.deletePrintLayout,
      setLoading,
    );
    setRefetch((prev) => !prev);
  };

  useEffect(() => {
    async function fetchBarcodeLayouts() {
      const printLayouts = await barcodeApiEndPoints.printLayouts();
      setBarcodePrintFormats(
        printLayouts.data.data.filter((layout) => layout.branchId === branchId),
      );
    }
    fetchBarcodeLayouts();
  }, [refetch]);

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Back />
        <GlobalDivider name="PRN Settings" />
      </div>
      <div style={{ padding: '20px' }}>
        <Row gutter={[16, 0]} justify="space-between">
          <Col xs={{ span: 24 }} lg={{ span: 8 }}></Col>
          <Col>
            <Button
              onClick={() => {
                navigate('prn');
              }}
            >
              Create PRN Layout
            </Button>
          </Col>
        </Row>
      </div>
      <div
        style={{
          padding: '20px',
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
        }}
      ></div>

      <GlobalModal
        isVisible={open}
        onConfirm={handleOk}
        onClose={() => setOpen(false)}
        type="delete"
      />
      {/* <AddPRN
        visible={addPRNModalVisible}
        onClose={() => {
          // setAddPRNModalVisible(false);
          // setSelectedLayout(null);
        }}
        selectedLayout={selectedLayout}
        branchList={branchList}
      /> */}

      <div style={{ display: 'flex', gap: '20px' }}>
        {barcodePrintFormats.map((format, index) => (
          <Card key={index}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                gap: '16px',
              }}
            >
              <h3 style={{ marginBottom: '1rem' }}>{format.heading}</h3>
              <div style={{ display: 'flex', gap: '8px' }}>
                <div
                  className="ant-button-edit"
                  onClick={() => {
                    navigate('prn', {
                      state: {
                        branchId: branchId,
                        formatId: format.referenceId,
                      },
                    });
                    // setAddPRNModalVisible(true);
                    // setSelectedLayout(format);
                  }}
                >
                  <Link size="medium" className="edit">
                    <EditFilled className="text-blue-300" />
                  </Link>
                </div>
                <div className="ant-button-delete">
                  <Link
                    size="medium"
                    onClick={() => {
                      setOpen(true);
                      setDelId(format.referenceId);
                    }}
                  >
                    <DeleteFilled className="delete" />
                  </Link>
                </div>
              </div>
            </div>
            {/* <BarcodePreview format={format} /> */}
          </Card>
        ))}
      </div>
    </div>
  );
};

export default PRNsettings;
